import React, { useEffect, useState } from "react";

const AnimatedCount = ({count}) =>{

    const [actualCount,setActualCount] = useState(0);

    useEffect(()=>{
        let intervalId;
        if(actualCount < count){
            intervalId = setInterval(()=>{
                setActualCount((prevCount) => {
                    if(prevCount < count) return prevCount + 1;
                    else{
                        clearInterval(intervalId);
                        return prevCount;
                    }
                });

            }, 50);
        }
        return () => clearInterval(intervalId);
    },[count]);

    return <span>{actualCount}</span>
}

export default AnimatedCount;